<template>
  <vue-dropzone
    @vdropzone-sending="addNameParameter"
    @vdropzone-success="uploaded"
    :options="dropzoneOptions"
    :id="id"
  >
  </vue-dropzone>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import { getToken } from '@/helpers/authentication';
import uuidv4 from 'uuid/v4';

export default {
  name: 'FileInput',
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    value: {},
    label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dropzoneOptions: {
        maxfilesexceeded(file) {
          this.removeAllFiles();
          this.addFile(file);
        },
        headers: {
          Authorization: `JWT ${getToken()}`,
        },
        maxFiles: 1,
        dictDefaultMessage: `${this.label} (Datei hierher ziehen oder klicken)`,
        url: '/api/files',
      },
    };
  },
  computed: {
    id: uuidv4,
  },
  methods: {
    addNameParameter(file, xhr, formData) {
      formData.append('name', file.name);
    },
    uploaded(file, response) {
      this.$emit('input', response.id);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~vue2-dropzone/dist/vue2Dropzone.min.css'
</style>
